import React, { useEffect, useRef, useState } from "react";
import styles from "./index.module.less";
import { Context,Hooks,Util,Request,Platform } from "@xt/xtbase";
import banner_affiliate from "assets/images/home/banner_affiliate.png";
import bannerImage from "@/assets/images/001.png";
import share from "assets/images/home/share.png";
import he1 from "assets/images/home/01.png";
import he2 from "assets/images/home/02.png";
import he3 from "assets/images/home/03.png";
import { get_profileInfo } from "@/api/referral";
import { get_channelApply, get_applyStatus, put_applyCallback } from "@/api/affiliate";
import ShareModal from "components/App/shareModal";
import CommonModal from "components/App/commonModal"
import CommonDrawer from "components/App/commonDrawer"
import { Table, Space, Modal, Spin } from "antd";
import { toUtc } from "utils/date";
import { getUrlSearchAttr } from 'utils/method';


const {XtContext,XtAuth} = Context;
const {getOrigin, getUrl, getXTUrl, Big} = Util;
const {useDocumentWidth, useTranslation} = Hooks;

function Banner() {
  const t = useTranslation();
  const domeWidth = (useDocumentWidth() ?? 0) > 768
  const [appState] = React.useContext(XtContext);
  const {loginStatus, lang, userInfo} = appState;
  const affiliateBannerDir =
    lang === "ar" || String(lang || "").toLowerCase().startsWith("ar") ? "rtl" : "ltr";
  console.log(loginStatus, 'loginStatus', userInfo)
  const {affiliate_banner, banner, header_bg, content, contentLeft, contentRight, operate, go, mbTip, go2, he1Img, footItem, foot, he2Img, he3Img, footItem1, footItem2, brandText, bannerImg} = styles
  const [loginQuery, setLoginQuery] = useState("");
  const [profileInfo, setProfileInfo] = useState({})
  const [copyLinkUrl, setCopyLinkUrl] = useState("");
  const [channelApply, setChannelApply] = useState([])
  // const [applyInfo, setApplyInfo] = useState({})
  const applyInfo = useRef({})
  const [isShowShareModal, setIsShowShareModal] = useState(false);
  const [isShowAuditModal, setIsShowAuditModal] = useState(false);
  const [isShowAuditDrawer, setIsShowAuditDrawer] = useState(false);
  const [isShowSureInvitationModal, setIsShowSureInvitationModal] = useState(false);
  // 身份未拉取完成前不展示依赖身份的按钮，避免误点跳错页
  const [identityReady, setIdentityReady] = useState(false);
  // 仅当「未登录」状态稳定一段时间后再展示「to become a partner」，避免拿到登录态前闪一下再变
  const [showLoginButton, setShowLoginButton] = useState(false);

  useEffect(() => {
    if (loginStatus !== 0) {
      setShowLoginButton(false);
      return;
    }
    const t = setTimeout(() => setShowLoginButton(true), 200);
    return () => clearTimeout(t);
  }, [loginStatus]);

  const showMainButtonLoading =
    loginStatus == null ||
    loginStatus === undefined ||
    (loginStatus == 1 && !identityReady) ||
    (loginStatus === 0 && !showLoginButton);

  useEffect(()=>{
    setLoginQuery("?backurl="+encodeURIComponent(location.href));
    const getData = async() => {
      if (loginStatus != 1) return;
      setIdentityReady(false);
      try {
        await Promise.all([getProfileInfo(), getChannelApply()]);
      } finally {
        setIdentityReady(true);
      }
      if (getUrlSearchAttr('applyId') && getUrlSearchAttr('type')) {
        getApply()
      }
    }
    if (loginStatus == 1) {
      getData()
    } else {
      setIdentityReady(false);
    }
  },[loginStatus]);

  const getProfileInfo = async() => {
    const profileInfo = await get_profileInfo()
    console.log(profileInfo, "profileInfo!!!")
    setProfileInfo(profileInfo || {})
    setCopyLinkUrl(Platform.isInApp() ? `${getXTUrl("/accounts/register")}?ref=${profileInfo?.inviteCode}` : `${getUrl("/accounts/register")}?ref=${profileInfo?.inviteCode}`);
    localStorage.setItem('isPartner', profileInfo?.isPartner);
  }

  const getChannelApply = async() => {
    const channelApply = await get_channelApply()
    setChannelApply(channelApply)
  }

  const getApply = async() => {
    try {
      const apply = await get_applyStatus({
        params:{
          id: getUrlSearchAttr('applyId'),
        }
      })
      applyInfo.current = apply
      // setApplyInfo(applyInfo || {})
      console.log(applyInfo.current, "apply")
      setIsShowSureInvitationModal(apply?.status ? true : false)
    }catch(error){
      setIsShowSureInvitationModal(false)
      console.log(error)
    }
  }

  // 分享
  const onShare = () => {
    setIsShowShareModal(true);
  };

  // 关闭分享弹层
  const onShareClose = () => {
    setIsShowShareModal(false);
  };

  // 确认邀请
  const onSureInvitation = () => {
    setIsShowSureInvitationModal(true);
  };

  // 关闭确认邀请
  const onSureInvitationClose = () => {
    setIsShowSureInvitationModal(false);
  };

  // 确认邀请  取消确认
  const onSave = async(isAccept) => {
    try {
      const res = await put_applyCallback({
        isResFull: true,
        successPop: true,
        params:{
          id: getUrlSearchAttr('applyId'),
          type: Number(getUrlSearchAttr('type')),
          isAccept
        }
      })
      console.log(res, "res!!!!!!")
      if (res && res.rc == 0) {
        setIsShowSureInvitationModal(false);
        getProfileInfo()
        getChannelApply()
      }
    }catch(error) {
      console.log(error)
      // setIsShowSureInvitationModal(false);
    }
   
  }

  //查看审核结果
  const onAudit = () => {
    getChannelApply()
    setIsShowAuditModal(true);
  };

  //关闭查看审核结果
  const onAuditClose = () => {
    getProfileInfo()
    setIsShowAuditModal(false);
  };

  //查看审核结果 Drawer
  const onAuditDrawer = () => {
    getChannelApply()
    setIsShowAuditDrawer(true);
  };

  //关闭查看审核结果 Drawer
  const onAuditDrawerClose = () => {
    getProfileInfo()
    setIsShowAuditDrawer(false);
  };

  const columns = [
    {
      title: t("home.submitDate"),
      dataIndex: 'time',
      key: 'time',
      render: (time) => toUtc(time),
    },
    {
      title: t("home.audit"),
      dataIndex: 'auditStatus',
      key: 'auditStatus',
      render: (_, record) => (
        <Space size="middle">
          {record.auditStatus == 0 && <span style={{color: '#B9F78A'}}>{t("home.auditStatus0")}</span>}
          {record.auditStatus == 1 && <span>{t("home.auditStatus1")}</span>}
          {record.auditStatus == 2 && <span style={{color: '#FD5760'}}>{t("home.auditStatus2")}</span>}
        </Space>
      ),
    },
    {
      title: t("home.remark"),
      dataIndex: 'rejectionReason',
      key: 'rejectionReason',
      width: 150,
      textWrap: 'word-break',
      render: (text, record) => (
        <div style={{ wordWrap: 'break-word', wordBreak: 'break-word' }}>
          {text}
        </div>
      ),
    },
  ]

  return (
    <div className={affiliate_banner} dir={affiliateBannerDir}>
      <div className={banner}>
        <div className={header_bg}></div>
        <div className={content}>
              <img src={bannerImage} className={bannerImg} alt="Banner" />
          <div className={contentLeft}>
            <h1>
              <span>
                {loginStatus == 1 && identityReady && profileInfo?.isPartner
                  ? t("home.joinProgramPartner")
                  : t("home.joinProgram")}
              </span>
            </h1>
            {domeWidth && (
              <>
                <p>
                  {loginStatus == 1 && identityReady && profileInfo?.isPartner
                    ? t("home.joinProgramTipPartner")
                    : t("home.joinProgramTip")}
                </p>
              </>
            )}
            {!domeWidth && (
              <div className={mbTip}>
                <p>
                  {loginStatus == 1 && identityReady && profileInfo?.isPartner
                    ? t("home.joinProgramTipPartner")
                    : t("home.joinProgramTip")}
                </p>
              </div>
            )}
            {/* <div className={operate}>
              <img src={share} onClick={onShare} />
            </div>
            <div className={go}>
            </div> */}
          </div>
        </div>
        <div className={foot}>
          <div className={footItem}>
            <img src={he1} className={he1Img} alt="" />
            <p lang={lang || undefined}>{ t("home.earn") }</p>
          </div>
          <div className={`${footItem} ${footItem1}`}>
            <img src={he2} className={he2Img} alt="" />
            <p lang={lang || undefined}>{ t("home.earn1") }</p>
          </div>
          <div className={`${footItem} ${footItem2}`}>
            <img src={he3} className={he3Img} alt="" />
            <p lang={lang || undefined}>{ t("home.earn2") }</p>
          </div>
        </div>
      </div>
      <ShareModal
        isShowModal={isShowShareModal}
        onClose={onShareClose}
        qrUrl={copyLinkUrl}
        inviteCode={profileInfo?.inviteCode}
      />
      <CommonModal width={516} title={t("home.audit")} isShowModal={isShowAuditModal} onClose={onAuditClose} commonModal={`commonModal auditModal ${styles.auditModalRoot}`}>
        <div className="AuditModal">
          <div style={{width: '100%'}}>
            <Table pagination={{pageSize: 8}} size="small" dataSource={channelApply} columns={columns} />
          </div>
        </div>
      </CommonModal>
      <CommonDrawer title={t("home.audit")} isShowModal={isShowAuditDrawer} onClose={onAuditDrawerClose} height={526} className={styles.auditDrawerRoot}>
        <div className="AuditDrawer">
          <Table pagination={false} size="small" dataSource={channelApply} columns={columns} />
        </div>
      </CommonDrawer>
      {isShowSureInvitationModal && <CommonModal width={domeWidth ? 400 : 280} title={t("home.sureInvitation")} isShowModal={isShowSureInvitationModal} onClose={onSureInvitationClose} closable={false}>
        <div className="SureInvitationModal">
          <div className="tip">{ getUrlSearchAttr('type') == 1 ? t("home.sureInvitationTip1") : t("home.sureInvitationTip")}{getUrlSearchAttr('type') == 1 ? `${(applyInfo.current.spotCommisionRate)}%` : ''}</div>
          <div className="foot1">
            <div className="cancel" onClick={() => onSave(0)}>{t("home.reject")}</div>
            <div className="save" onClick={() => onSave(1)}>{t("home.sure")}</div>
          </div>
        </div>
      </CommonModal>}
    </div>
  );
}

export default Banner;
